"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Atom = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const base_1 = require("./base");
var Atom;
(function (Atom) {
    /**
     * Create an atom with given initial value.
     *
     * @export
     * @template T type of atom values
     * @param initialValue initial value for this atom
     * @returns fresh atom
     */
    function create(initialValue) {
        return new base_1.JsonAtom(initialValue);
    }
    Atom.create = create;
    // tslint:enable no-unused-vars
    function log(atom, logger) {
        const logState = (msg, color, x) => console.log("%c" + msg, `color: ${color}; font-weight: bold`, x);
        let prevState = atom.get();
        atom.subscribe(newState => {
            if (typeof logger === "function") {
                logger(prevState, newState);
            }
            else {
                console.group(`UPDATE ${logger ? `TYPE: ${logger} ` : ""}@ ${new Date().toTimeString()}`);
                logState("prev state", "#9E9E9E", prevState);
                logState("next state", "#4CAF50", newState);
                console.groupEnd();
            }
            prevState = newState;
        });
        return atom;
    }
    Atom.log = log;
    // tslint:enable no-unused-vars
    function combine(...args) {
        return new base_1.CombinedAtomViewImpl(args.slice(undefined, -1), xs => args[args.length - 1](...xs));
    }
    Atom.combine = combine;
    /**
     * Converts an observable to a read-only atom.
     *
     * The returned atom is wrapped into an observable, which will only emit a single value.
     * The source observable will only be subscribed to for as long as there is at least one
     * subscription to the returned observable.
     *
     * The returned observable never completes and controls the lifecycle of the emitted atom:
     * as long as it's subscribed to, the returned atom will have its value updated from the
     * source observable.
     *
     * @export
     * @template T type of atom values
     * @param src the source observable
     * @returns an observable that emits a read-only atom
     */
    function fromObservable(src) {
        const atomSubj = new rxjs_1.BehaviorSubject(null);
        const initAndUpdateAtom = src.pipe(operators_1.tap(x => {
            const atom = atomSubj.value;
            if (atom === null) {
                atomSubj.next(Atom.create(x));
            }
            else
                atom.set(x);
        }), 
        // prevent updating atom multiple times to the same value
        operators_1.share());
        return new rxjs_1.Observable(o => {
            const sub = new rxjs_1.Subscription();
            sub.add(atomSubj.pipe(operators_1.filter((x) => !!x)).subscribe(o));
            sub.add(initAndUpdateAtom.subscribe(undefined, 
            // propagate errors
            e => o.error(e), 
            // propagate completion
            () => o.complete()));
            return sub;
        });
    }
    Atom.fromObservable = fromObservable;
    function set(atom, observable) {
        return new rxjs_1.Observable(s => {
            const sub = observable.subscribe(next => atom.set(next), e => s.next(e), () => s.complete());
            s.add(sub);
        });
    }
    Atom.set = set;
})(Atom = exports.Atom || (exports.Atom = {}));
